import { render, staticRenderFns } from "./ChildBtn.vue?vue&type=template&id=cfb27ca2&scoped=true&"
import script from "./ChildBtn.vue?vue&type=script&lang=js&"
export * from "./ChildBtn.vue?vue&type=script&lang=js&"
import style0 from "./ChildBtn.vue?vue&type=style&index=0&id=cfb27ca2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb27ca2",
  null
  
)

export default component.exports